import createCache from "@emotion/cache";

// Client-side cache, shared for the whole session of the user in the browser.
const createEmotionCache = () =>
    createCache({ key: "mandobcss", prepend: true });

export default createEmotionCache;
